<template>
  <section class="flex flex-col gap-3">
    <rpm-input class="w-full" label="Nome do Grupo" v-model="group.label" @blur="updateGroup(group.label, 'label')"></rpm-input>

    <rpm-input type="editor" label="Descrição do grupo" v-model="group.description"></rpm-input>

    <rpm-draggable
      :list="group.questions"
      v-slot="{ item: question }"
      class="flex flex-col gap-2"
    >
      <rpm-accordion
        class="w-full rounded border border-gray-500/20"
        :absolute-open="openedAccordions[question.id]"
      >
        <template #header>
          <div
            class="w-full grid grid-cols-[auto_1fr] p-3 bg-black/5 dark:bg-white/5"
            :class="openedAccordions[question.id] ? 'border-b border-gray-500/20' : ''"
          >
            <div class="flex flex-row items-center gap-3">
              <i class="fa-solid fa-grip-lines cursor-move"></i>
              <span class="text-md font-bold">
                {{ question.label }}
              </span>
            </div>
            <div class="flex flex-row-reverse items-center gap-2">
              <rpm-button
                color-class="text-red-500 hover:text-red-600 focus:text-red-600"
                font-class="text-2xl"
                icon="fa-solid fa-trash"
                tooltip-text="excluir questão"
                @click.stop="deleteQuestion(question)"
              ></rpm-button>
              <rpm-input
                type="switch"
                wrapper-class="h-[28px]"
                :tooltip-text="question.enabled ? 'desabilitar questão':'habilitar questão'"
                @click.stop="updateQuestion(question)"
                v-model="question.enabled"
              ></rpm-input>
            </div>
          </div>
        </template>

        <template #default>
          <div class="w-full p-3">
            <question :question="question" :field-types="fieldTypes"></question>
          </div>
        </template>
      </rpm-accordion>
    </rpm-draggable>

    <div class="flex flex-row items-center justify-center">
      <rpm-button
          icon="fa-solid fa-plus"
          class="px-3 py-1.5 rounded-md"
          tooltip-text="adicionar questão"
          font-class="text-md"
          @click="addQuestion"
      ></rpm-button>
    </div>
  </section>
</template>

<script>

import RpmDraggable from "#components/RpmDraggable.vue";
import RpmAccordion from "#components/RpmAccordion.vue";
import fieldTypeRepository from "#repositories/fieldTypeRepository";
import questionStore from "#repositories/questionRepository";
import GroupStore from '#repositories/groupRepository'

import Question from "./question.vue";

import _ from "lodash";

export default {
  name: "Group",
  components: {
    Question,
    RpmDraggable,
    RpmAccordion,
  },
  data() {
    return {
      openedAccordions: {},
      defaultQuestion: {},
      fieldTypes: [],
      descriptionTimer: null,
    };
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openAccordion(id) {
      this.openedAccordions[id] = !this.openedAccordions[id];
    },
    async getFieldTypes() {
      this.fieldTypes = (
          await fieldTypeRepository.getFieldTypes()
      ).data;
    },
    async addQuestion() {
      this.defaultQuestion["hint"] = null;
      this.defaultQuestion["label"] = `Questão ${this.group.questions.length + 1}`;
      let response = (await questionStore.storeQuestion(this.defaultQuestion)).data;
      this.group.questions.push(response);
    },
    updateGroup(value, field){
      GroupStore.updateGroup(this.group.id, {
        [field]: value,
        questionnaire_id: this.$attrs.questionnaire.id
      }).then((response) => {
        this.$notify(response.message, response.severity)
      })
    },
    async deleteQuestion(question) {
      let response = (await questionStore.deleteQuestion(question.id)).data;
      this.group.questions = _.reject(this.group.questions, (element) => {
        return element.id === response.id;
      });
    },
    updateQuestion(question) {
      questionStore.updateQuestion(question.id, { enabled: !question.enabled })
    }
  },
  mounted() {
    this.getFieldTypes()
  },
  watch: {
    fieldTypes() {
      let fieldType = _.find(this.fieldTypes, {'label': 'text'})
      this.defaultQuestion = {
        field_type_id: fieldType.id,
        group_id: this.group.id,
        label: `Questão ${this.group.questions.length + 1}`,
        hint: null ,
        max: 0,
        min: 0,
        mask: null,
        required: false,
        enabled: true,
        allows_does_not_apply: false
      }
    },
    'group.description'() {
      clearTimeout(this.descriptionTimer);
      this.descriptionTimer = setTimeout(() => this.updateGroup(this.group.description, 'description'), 2000);
    },
    
  }
}
;
</script>
